import { format } from "date-fns";
import React from "react";
import { FaCircle } from "react-icons/fa";

import { Paragraph } from "@fronterahealth/frontera-ui-components";

import { ChatType } from "@api/graphql/types-and-hooks";
import { parseJson } from "@components/FieldComponent/utils";

interface ChatHistoryProps {
  chat: ChatType;
}

interface ChatHistoryType {
  title: string;
  description: string;
  date: string;
}

export const ChatHistory: React.FC<ChatHistoryProps> = ({ chat }) => {
  const chatHistory = parseJson<ChatHistoryType[]>(chat.history) ?? [];

  if (chatHistory.length === 0) {
    return (
      <div className="flex flex-row justify-center">
        <Paragraph size="small">No history to show.</Paragraph>
      </div>
    );
  }

  return (
    <div className="flex flex-col gap-4 overflow-y-auto no-scrollbar">
      {chatHistory.map((history, index) => {
        const isLast = index === chatHistory.length - 1;
        return (
          <div key={index} className="flex flex-row gap-4 px-4">
            <div className="relative flex flex-col items-center">
              {index !== 0 && <div className="absolute -top-4 h-[26px] w-0.5 bg-[#E5E1D6]" />}

              <div className="z-10">
                <FaCircle className="max-w-4! max-h-4! min-w-4! min-h-4! text-[#1C4A50] mt-[2px]" />
              </div>

              {!isLast && <div className="absolute top-[10px] -bottom-4 w-0.5 bg-[#E5E1D6]" />}
            </div>
            <div className="flex flex-col">
              <Paragraph className="text-[#706B61] leading-[16px]">
                {format(new Date(history.date), "MMM d, yyyy, h:mma")}
              </Paragraph>
              <Paragraph displayType="loud" className="text-[#0E2528]">
                {history.title}
              </Paragraph>
              <Paragraph className="text-[#0E2528]">{history.description}</Paragraph>
            </div>
          </div>
        );
      })}
    </div>
  );
};
